import React from "react";
import s from "./styles.scss";
import withStyles from "isomorphic-style-loader/withStyles";
import WizardFormStep from "../../components/WizardFormStep";
import FormFieldRow from "../components/FormFieldRow";
import FormInput from "../../../../../../toolkit/formInput";
import * as yup from "yup";
import {
  createRequiredTextField,
  createUrlField,
} from "../../../../../../utils/validation/validationUtils";

export const supportContactFormSchema = yup.object({
  organizationWebsiteUrl: createUrlField("Organization website URL"),
});

const SupportContactForm: React.FC = () => {
  return (
    <WizardFormStep
      title="Website Setup"
      subtitle="Please provide your organization website URL."
      className={s.formContainer}
    >
      <FormFieldRow spacing="first">
        <FormInput
          name="organizationWebsiteUrl"
          type="url"
          icon={"fa-solid fa-globe"}
          placeholder="Organization Website URL"
        />
      </FormFieldRow>
    </WizardFormStep>
  );
};

export default withStyles(s)(SupportContactForm);
